import { Injectable } from "@angular/core";
import { ResourceService } from "./resource.service";
import { ProcessModel } from "../model/process.model";
import { HttpClient, HttpParams } from "@angular/common/http";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { SearchParamsModel } from "../model/search-params.model";
import { PagingContainerModel } from "../model/paging-container.model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class WorkflowGatewayService extends ResourceService<ProcessModel> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authService: AuthenticationService) {
        super(http, "gateway/Processos", settings.processosUrl, authService)
    }

    getSummary(pageNumber: number = 1,
        pageSize: number,
        options?: {
            searchParams?: SearchParamsModel
        },
        customBaseUrl?: string
        ) {

        let baseUrl = customBaseUrl || 'gateway/Processos';

        let params = this.BuildProcessSearchParams(pageNumber, pageSize, options);

        let query = `?${params.toString()}`

        return this.getWithComplement<PagingContainerModel>(query, customBaseUrl)
    }

    getCount(
        pageSize: number,
        options?: {
            searchParams?: SearchParamsModel
        },
        customBaseUrl?: string
    ): Observable<{ totalItems: number; totalPages: number }> {
        const params = this.BuildProcessSearchParams(1, pageSize, options);
        const query = `Count?${params.toString()}`;
        return this.getWithComplement<{ totalItems: number; totalPages: number }>(query, customBaseUrl);
    }

    deleteProcess(processId: string): Observable<any> {
        return this.delete(processId)
    }
}
